import { FieldConfig, SearchFormTypes } from '../../../Shared/Components/SearchFormWrapper';
import { OfferSearchFilters } from '../../Types/offerTypes';

export const fieldsSearch: FieldConfig<OfferSearchFilters>[] = [
  {
    name: 'searchTerm',
    label: 'Szukaj (oferta, hotel, region, kraj, kategoria, firma, tag)',
    type: SearchFormTypes.input,
    value: '',
  },
  {
    name: 'categoryId',
    label: 'Kategoria',
    type: SearchFormTypes.select,
    options: [],
    value: '',
  },
  {
    name: 'hotelId',
    label: 'Hotel',
    type: SearchFormTypes.autocomplete,
    options: [],
    value: '',
  },
  {
    name: 'countryId',
    label: 'Kraj',
    type: SearchFormTypes.autocomplete,
    options: [],
    value: '',
  },
  {
    name: 'regionId',
    label: 'Region',
    type: SearchFormTypes.autocomplete,
    options: [],
    value: '',
  },
  {
    name: 'companyId',
    label: 'Firma',
    type: SearchFormTypes.select,
    options: [],
    value: '',
  },
  {
    name: 'published',
    label: 'Opublikowany',
    type: SearchFormTypes.select,
    options: [
      { id: 'true', name: 'Tak' },
      { id: 'false', name: 'Nie' },
    ],
    value: '',
  },
];
